module.exports = __webpack_public_path__ + "static/img/DSC02509.48b709f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC02509.jpg
// module id = BJop
// module chunks = 0